import React from "react";
import { Column, Columns, Stack } from "@origin-digital/ods-core";
import { dobDay } from "@origin-digital/normalize";
import { TextFieldWrapper } from "../TextFieldWrapper/TextFieldWrapper";
import { validator } from "./helper";
import { DateOfBirthFieldProps } from "./types";

export const DateOfBirthField: React.FC<DateOfBirthFieldProps> = ({
  onAccept,
  onDeny,
  value: incomingValue,
  error: incomingError,
  ...props
}) => {
  const id = "date-of-birth";

  // Convert Date to String
  const [value, setValue] = React.useState<string | undefined>(() => {
    if (incomingValue instanceof Date && !isNaN(incomingValue.getTime())) {
      const day = String(incomingValue.getDate()).padStart(2, "0");
      const month = String(incomingValue.getMonth() + 1).padStart(2, "0");
      const year = String(incomingValue.getFullYear());
      return `${day}/${month}/${year}`;
    } else {
      return undefined;
    }
  });

  const error: boolean | undefined = React.useMemo(() => {
    if (typeof incomingError === "undefined") return undefined;
    if (incomingError === "") return false;
    return true;
  }, [incomingError]);

  const handleOnAccept = (accepted: string) => {
    try {
      const [day, month, year] = accepted.split("/").map(Number);
      // Month is 0-based in JS Date
      const date = new Date(year, month - 1, day);
      if (
        !isNaN(date.getTime()) &&
        onAccept &&
        date.getDate() === day &&
        date.getMonth() === month - 1 &&
        date.getFullYear() === year
      ) {
        onAccept?.(date);
      }
    } catch (e) {}
  };

  const handleOnDeny = (denied: string, deniedValue?: string) => {
    onDeny(denied, deniedValue ? new Date(deniedValue) : null);
  };

  return (
    <Stack space="small">
      {/* The form tag is needed to turn off Chrome autofill for this field.  Otherwise it will think its a Credit Card field and offer saved credit card dropdown */}
      <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
        <Columns space="none" collapseBelow="md">
          <Column width="flex">
            <TextFieldWrapper
              data-hj-suppress={true}
              id={id}
              data-id={id}
              label="Date of birth"
              placeholder="DD/MM/YYYY"
              maxLength={10}
              showCharacterCount={true}
              validator={validator(props.rules)}
              transform={dobDay}
              value={value}
              error={error}
              setValue={setValue}
              onAccept={handleOnAccept}
              onDeny={handleOnDeny}
              endIcon={<></>}
              {...props}
            />
          </Column>
        </Columns>
      </form>
    </Stack>
  );
};
